import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, ArrowRight } from "lucide-react";
import SEO from "@/components/site/SEO";

const COPY = {
  forum: {
    title: "Forum sedang dinonaktifkan sementara",
    body: "Forum sedang dinonaktifkan sementara. Anda tetap dapat membaca artikel dan mengikuti diskusi pada artikel pilihan di The Reports.",
  },
  reviews: {
    title: "Fitur ini sementara tidak tersedia",
    body: "Ulasan sekolah sedang dinonaktifkan sementara. Anda tetap dapat membaca artikel dan mengikuti diskusi pada artikel pilihan di The Reports.",
  },
};

export default function FeatureDisabled({ feature = "forum" }) {
  const c = COPY[feature] || COPY.forum;
  return (
    <div data-testid={`feature-disabled-${feature}`} className="max-w-2xl mx-auto px-6 py-24">
      <SEO title={`${c.title} | The School Reports`} description={c.body} robots="noindex,follow" />
      <div className="w-12 h-12 rounded-2xl bg-[#F6E7DF] text-[#BE5730] flex items-center justify-center">
        <BookOpen size={22} />
      </div>
      <h1 className="font-serif-display text-3xl sm:text-4xl text-[#0F1F3D] mt-6 leading-tight" data-testid="feature-disabled-title">
        {c.title}
      </h1>
      <p className="mt-4 text-[#4B5563] leading-relaxed" data-testid="feature-disabled-body">{c.body}</p>
      <Link
        to="/"
        data-testid="feature-disabled-cta"
        className="mt-8 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-[#0F1F3D] text-white text-sm font-semibold hover:bg-[#1E3A8A] transition-colors"
      >
        Jelajahi The Reports <ArrowRight size={16} />
      </Link>
    </div>
  );
}
